import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import container from '../../helpers/container'
import config from 'config'
import {
  ContainerDivs,
  AmazonStaffTakeActionShare,
  PlanScorecardToActionCenter,
  AmazonVanguardLetters,
} from '../../components'
import Styles from './AmazonVanguardThanks.css'


@CSSModules(Styles, {allowMultiple:true})
export default class AmazonVanguardThanks extends Component {
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const pageTitle = 'Thanks for your support'
    //
    return (
      <div styleName='gray-bckgrnd'>
        <div styleName='page'>
          {
            container.helmet(
              pageTitle,
              'Thanks for your support for our petition calling on Vanguard to offer Amazon employees more sustainable 401(k) options.',
              config.domain + config.routes.amazonVanguardThanks
            )
          }
          <ContainerDivs>
            <h1 styleName='large-page-title'>
              Thank you for your support!
            </h1>
          <AmazonVanguardLetters />
          <AmazonStaffTakeActionShare />
          </ContainerDivs>
          <PlanScorecardToActionCenter />
          <br/>
          <br/>
          <br/>
        </div>
      </div>
    )
  }
}
